/**
 * Core (generic) card renderers. Registered once at bootstrap, before module
 * contributions, so a module can override any type for its own `moduleId`.
 *
 * `strategy_list` / `strategy_detail` / `comparison` get a generic placeholder
 * here: finance overrides them, but a client without the finance module still
 * renders something honest instead of an unknown-card box.
 */
import { registerCardRenderer } from './registry.js';

export function registerCoreCardRenderers(): void {
  registerCardRenderer('status_summary', () =>
    import('./core/StatusSummaryCard.js').then((m) => ({ default: m.StatusSummaryCard })),
  );
  registerCardRenderer('entity_list', () =>
    import('./core/EntityListCard.js').then((m) => ({ default: m.EntityListCard })),
  );
  registerCardRenderer('entity_detail', () =>
    import('./core/EntityDetailCard.js').then((m) => ({ default: m.EntityDetailCard })),
  );
  registerCardRenderer('work_progress', () =>
    import('./core/WorkProgressCard.js').then((m) => ({ default: m.WorkProgressCard })),
  );
  registerCardRenderer('approval_request', () =>
    import('./core/ApprovalRequestCard.js').then((m) => ({ default: m.ApprovalRequestCard })),
  );
  registerCardRenderer('clarification', () =>
    import('./core/ClarificationCard.js').then((m) => ({ default: m.ClarificationCard })),
  );
  registerCardRenderer('proactive_prompt', () =>
    import('./core/ProactivePromptCard.js').then((m) => ({ default: m.ProactivePromptCard })),
  );
  registerCardRenderer('connection_setup', () =>
    import('./core/ConnectionSetupCard.js').then((m) => ({ default: m.ConnectionSetupCard })),
  );

  for (const moduleOwnedType of ['strategy_list', 'strategy_detail', 'comparison']) {
    registerCardRenderer(moduleOwnedType, () =>
      import('./core/ModuleCardFallback.js').then((m) => ({ default: m.ModuleCardFallback })),
    );
  }
}
